import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Tabbar.module.css';

const Tabbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className={styles.tabbar}>
      <ul>
        <Link
          to="/content"
          className={`${currentPath === '/content' ? styles.activated : ''}`}
        >
          <li className={styles.content}>Content</li>
        </Link>
        <Link
          to="/dashboard"
          className={`${currentPath === '/dashboard' ? styles.activated : ''}`}
        >
          <li className={styles.dashboard}>Dashboard</li>
        </Link>
        <Link
          to="/pricing"
          className={`${currentPath === '/pricing' ? styles.activated : ''}`}
        >
          <li className={styles.pricing}>Pricing</li>
        </Link>
        <Link
          to="/settings"
          className={`${currentPath === '/settings' ? styles.activated : ''}`}
        >
          <li className={styles.settigns}>Settings</li>
        </Link>
        <Link
          to="/category"
          className={`${currentPath === '/category' ? styles.activated : ''}`}
        >
          <li className={styles.category}>Category</li>
        </Link>
        {/* <Link
          to="/cobranding"
          className={`${
            currentPath === "/cobranding" ? styles["activated"] : ""
          }`}
        >
          <li className={styles["co-branding"]}>Co-Branding</li>
        </Link> */}
      </ul>
    </nav>
  );
};

export default Tabbar;
